import { ArticleType } from "../enums/articleTypeEnum";

export interface ArticleTemplate {
    id: string;
    description: string;
    articleNumber: string;
    salesPrice: string;
    keepIncomingPrice: boolean;
    articleType?: ArticleType;
}

export const defaultArticleTemplate: ArticleTemplate =
{
    id: "",
    description: "",
    articleNumber: "",
    salesPrice: "0",
    keepIncomingPrice: false,
    articleType: ArticleType.Product
}